<template>
  <div class='popup-wrap-not_fixed' style='background-color:black;'>
    <div class='head-menu'>
      <i v-if='isParent===false' class="fa fa-times menu-close text-button" @click="onClose()"></i>
      <div class='menu-title'>
        <span class='text-button' @click="onFileSelect()">이미지선택</span>
        <span v-if='isImgSelected' style='margin:0 6px;'>|</span>
        <span class='text-button' v-if='isImgSelected' @click="onCropImage()">확인</span>
      </div>
    </div>
    <input id='selectImg' type="file" name="image" accept="image/*" @change="setImage" style='display:none'/>
    <div class='croper-wrap' >
      <vue-cropper v-if='imgSrc'
          ref='cropper'
          :guides="true"
          :view-mode="2"
          drag-mode="move"
          :auto-crop-area="1.0"
          :aspectRatio="1/1"
          :min-container-width="300"
          :min-container-height="300"
          :background="false"
          :rotatable="true"
          :src="imgSrc"
          :checkCrossOrigin="cross"
          :img-style="imgStyle">
      </vue-cropper>
    </div>
     <loading :active.sync="isLoading" :is-full-page='fullPage'></loading>
  </div>
</template>

<script>
import 'babel-polyfill'
import VueCropper from 'vue-cropperjs'
import 'cropperjs/dist/cropper.css'
// import FileService from '../../share/service/FileService'
import Loading from 'vue-loading-overlay'

export default {
  name: 'imageCrop',
  props: {
    popup: Boolean
  },
  components: {
    VueCropper,
    Loading
  },
  data: function () {
    return {
      isLoading: false,
      fullPage: true,
      imgSrc: null,
      cropImg: '',
      imgStyle: {},
      cross: true,
      imgSrcQuery: null,
      isImgSelected: false,
      isParent: this.popup
    }
  },
  created: function () {
    // this.imgSrc = this.$route.query.src
    this.imgSrcQuery = this.$route.query.src
    this.imageLoad(this.$route.query.src)
  },
  mounted: function () {
    /*
    if(this.isParent) {
      this.$Q('.popup-wrap-not_fixed').css('padding-top','0px')
    } */
    // let w = window.innerWidth
    // let h = window.innerHeight
    // this.imgStyle.width = (w-100) + 'px'
    // this.imgStyle.height = (w-100) + 'px'
    /*
    this.$Q('.popup-wrap-not_fixed').css('height', h + 'px')
    this.$Q('.croper-wrap').css('height', '100%')
    this.$Q('.croper-wrap').css('line-height', (h - 150) + 'px') */
  },
  updated: function () {

  },
  computed: {

  },
  methods: {
    setImage (e) {
      this.isImgSelected = true
      const file = e.target.files[0]
      if (!file.type.includes('image/')) {
        this.$snotify.error('Please select an image file')
        return
      }
      if (typeof FileReader === 'function') {
        const reader = new FileReader()
        reader.onload = (event) => {
          this.imgSrc = event.target.result
          // rebuild cropperjs with the updated source
          this.$refs.cropper.replace(event.target.result)
        }
        reader.readAsDataURL(file)
      } else {
        this.$snotify.error('Sorry, FileReader API not supported')
      }
      this.imgSrcQuery = ''
    },
    onCropImage () {
      if (this.imgSrcQuery.indexOf('user-circle.png') >= 0) {
        this.$snotify.error('선택된 이미지가 없습니다.')
        return
      }
      this.isLoading = true
      /*
      // let newBlob = new Blob([this.$refs.cropper.getCroppedCanvas().toDataURL('image/png')], { type: "image/png" })
      let image = this.$refs.cropper.getCroppedCanvas().toDataURL('image/png')
      image = image.replace('data:image/png;base64,', '')
      let blobPng = new Blob([image], { type: "image/png" });
      console.log(blobPng)
      this.$store.commit('saveTempArgData', image)
      this.onClose()
*/

      this.cropImg = this.$refs.cropper.getCroppedCanvas({ width: 300, height: 300 }).toBlob((blob) => {
        console.log(blob)
        // let blobPng = new Blob([blob], { type: "image/png" });
        // console.log(blobPng)
        this.$store.commit('saveTempArgData', blob)
        this.isLoading = false
        this.onClose()
      })
    },
    onCropSave () {

    },
    onFileSelect () {
      this.$Q('#selectImg').click()
    },
    onClose () {
      console.log(this.isParent)
      if (this.isParent === false) {
        this.$router.go(-1)
      } else {
        this.$emit('savePhoto')
      }
    },
    imageLoad (url) {
      /*
      FileService.getImgLoad(url)
        .then((data) => {
          this.imgSrc = URL.createObjectURL(data)
        }) */
    }

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->eight:100%
<style scoped lang="scss">
.popup-wrap-not_fixed {
  z-index:2000;
  width:400px;
  height:700px;
  background:black;
  padding-top:50px;
  border-radius: 6px;
  margin: 30px auto;
  position: relative;

  .head-menu{
    background-color: rgba(0,0,0,0.0);
    position:absolute;
    height:60px;
    top:0;
    left:0;
    width:400px;
    // border-bottom:1px solid white;
    color:white;
    text-align: right;
    padding-top:10px;
    z-index: 3000;
    background-color: rgba(0,0,0,0.3);
    .menu-close{
      position:absolute;
      left:0px;
      top:10px;
      height:50px;
      width:50px;
      margin-left:10px;
      font-size:1.5rem;
      text-align:left;
    }
    .menu-title{
      position:absolute;
      right:10px;
      top:10px;
    }
    .text-button:hover {
      cursor: pointer;
    }
  }
}
  .croper-wrap{
    margin:30px auto 0 auto;
    overflow:hidden;
    width:300px;
    height:600px;
    img{
      width:100%;
    }
  }
</style>
